export const DEFAULT_SIMULATOR_VALUES = {
	financeCreditCosts: false,
	financedLoanAmountFromOverview: 0,
	isPrestige: false,
	useCostFinancingDefaults: false,
};
